module.exports = __webpack_public_path__ + "static/media/old-final.2c7c7009.svg";